import { AppBar, Toolbar, Typography, Box, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import "./Navbar.scss";
import Menus from "../../../Components/Menu/Menu";
import {
  clearListuser,
  listUser,
} from "../../../Redux/Slices/User/ListUserSlice";
import { clearLoginStatus } from "../../../Redux/Slices/LoginSlicer/LoginSlicer";
import { clearDashboardChart } from "../../../Redux/Slices/DashboardChart/DashboardChart";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Redux/Store/Hooks";
import IconButtonField from "../../../Components/Button/IconButtonField";
import Avatars from "../../../Components/Avatar/Avatars";
import { useEffect, useState } from "react";

interface NavbarProps {
  toggleSidebar?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ toggleSidebar }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { data: DashboardCards } = useAppSelector(
    (state) => state.DashboardChart
  );

  const Dashboarduser: any = DashboardCards?.data;

  const [username, setUsername] = useState<string>("");

  useEffect(() => {
    dispatch(listUser());

    const storedUsername = sessionStorage.getItem("username");
    if (storedUsername) {
      const formatted =
        storedUsername.charAt(0).toUpperCase() +
        storedUsername.slice(1).toLowerCase();
      setUsername(formatted);
    } else {
      setUsername("User");
    }
  }, [dispatch]);

  return (
    <AppBar position="static" className="navbar">
      <Toolbar className="navbar-toolbar">
        <Box className="navbar-left">
          {toggleSidebar && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={toggleSidebar}
              className="mobile-menu-button"
            >
              <MenuIcon />
            </IconButton>
          )}
        </Box>

        {/* Right side: username and avatar */}
        <Box className="navbar-right">
          <Typography variant="subtitle1" className="navbar-text">
            <span className="navbar-subtext">Hi, Welcome Back,</span>{" "}
            <span className="navbar-username">Tutor {username}</span>
          </Typography>

          <div style={{ display: "flex", alignItems: "center" }}>
            <Menus
              menuItems={[
                {
                  menu: "Logout",
                  onClick: () => {
                    sessionStorage.clear();
                    dispatch(clearListuser());
                    dispatch(clearLoginStatus());
                    dispatch(clearDashboardChart());
                    navigate("/login");
                  },
                },
              ]}
            >
              <IconButtonField onClick={() => {}}>
                <Avatars sx={{ height: "2rem", width: "2rem" }} />
              </IconButtonField>
            </Menus>
          </div>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
